import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';

// A single shimmering placeholder block. Compose several to mirror the shape of the
// content that's loading (a tile, a text line, an avatar) so the layout doesn't shift
// when real data replaces it.
@Component({
	selector: 'nha-skeleton',
	template: '',
	styleUrls: ['skeleton.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	host: {
		'class': 'nha-skeleton',
		'role': 'presentation',
		'aria-hidden': 'true',
		'[class.nha-skeleton--circle]': 'circle()',
		'[style.width]': 'width()',
		'[style.height]': 'height()',
		'[style.border-radius]': 'circle() ? null : radius()'
	}
})
export class NHASkeletonComponent {
	width = input<string>('100%');
	height = input<string>('1rem');
	radius = input<string>('8px');
	circle = input<boolean>(false);
}
